import { render, staticRenderFns } from "./manage-email-receivers.vue?vue&type=template&id=5d7939d0&scoped=true&"
import script from "./manage-email-receivers.ts?vue&type=script&lang=ts&"
export * from "./manage-email-receivers.ts?vue&type=script&lang=ts&"
import style0 from "./manage-email-receivers.vue?vue&type=style&index=0&id=5d7939d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d7939d0",
  null
  
)

export default component.exports